export default __webpack_public_path__ + "static/media/mp3.f046c047.svg";